import { Button, DatePicker, Space, Typography } from "antd";
import dayjs from "dayjs";
import { DESCEND } from "common/constants";

const { Text } = Typography;
const { RangePicker } = DatePicker;

export const columnSorterFunc = (a, b, field) => {
    const valA = a?.[field];
    const valB = b?.[field];
    if (valA === valB) return 0;
    if (valA == null) return -1;
    if (valB == null) return 1;
    if (typeof valA === "number" && typeof valB === "number")
        return valA - valB;
    return String(valA).localeCompare(String(valB));
};

export const columnDef_batchId = {
    title: "ID",
    dataIndex: "id",
    key: "id",
    width: "90px",
    sorter: (a, b) => columnSorterFunc(a, b, "id"),
    render: (text) => <Text copyable={{ text: String(text) }}>{text}</Text>,
};

export const columnDef_brand = {
    title: "Brand",
    dataIndex: "brandName",
    key: "brandName",
    sorter: (a, b) => columnSorterFunc(a, b, "brandName"),
};

export const columnDef_cutoffDate = {
    title: "Cutoff Date",
    dataIndex: "cutoffDate",
    key: "cutoffDate",
    sorter: (a, b) => columnSorterFunc(a, b, "cutoffDate"),
    render: (text) => (text ? dayjs(text).format("MMM DD, YYYY HH:mm") : "—"),
    width: "175px",
};

export const columnDef_paymentDate = {
    title: "Payment Date",
    dataIndex: "paymentDate",
    key: "paymentDate",
    defaultSortOrder: DESCEND,
    sorter: (a, b) => columnSorterFunc(a, b, "paymentDate"),
    render: (text) => (text ? dayjs(text).format("MMM DD, YYYY HH:mm") : "—"),
    width: "175px",
    filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
    }) => (
        <div
            style={{ padding: 8, width: 340 }}
            onKeyDown={(e) => e.stopPropagation()}>
            <RangePicker
                value={selectedKeys[0] || null}
                onChange={(dates) => setSelectedKeys(dates ? [dates] : [])}
                style={{ marginBottom: 8, width: "100%" }}
            />
            <Space>
                <Button type="primary" size="small" onClick={() => confirm()}>
                    Filter
                </Button>
                <Button
                    size="small"
                    onClick={() => {
                        clearFilters?.();
                        confirm();
                    }}>
                    Reset
                </Button>
            </Space>
        </div>
    ),
    onFilter: (value, record) => {
        const recordDate = record.paymentDate;
        if (!recordDate) return false;
        const [start, end] = value || [];
        const d = dayjs(recordDate);
        if (start && d.isBefore(dayjs(start), "day")) return false;
        if (end && d.isAfter(dayjs(end), "day")) return false;
        return true;
    },
};

export const columnDef_paymentStatus = {
    title: "Payment Status",
    dataIndex: "statusDescr",
    key: "statusDescr",
    sorter: (a, b) => columnSorterFunc(a, b, "statusDescr"),
    width: "160px",
    // `filters` is injected at render time from loaded data (AutomatedPaymentBatches.js)
    filterSearch: true,
    onFilter: (value, record) => record.statusDescr === value,
};

export const columnDef_processedDate = {
    title: "Processed Date",
    dataIndex: "processedDate",
    key: "processedDate",
    sorter: (a, b) => columnSorterFunc(a, b, "processedDate"),
    render: (text) => (text ? dayjs(text).format("MMM DD, YYYY HH:mm") : "—"),
    width: "175px",
};

export const columnDef_achStatus = {
    title: "ACH Status",
    dataIndex: "achTransferStatusDescr",
    key: "achTransferStatusDescr",
    sorter: (a, b) => columnSorterFunc(a, b, "achTransferStatusDescr"),
    width: "140px",
    // `filters` is injected at render time from loaded data (AutomatedPaymentBatches.js)
    filterSearch: true,
    onFilter: (value, record) => record.achTransferStatusDescr === value,
};

export const automatedPaymentBatchColumns = [
    columnDef_batchId,
    columnDef_brand,
    columnDef_cutoffDate,
    columnDef_paymentDate,
    columnDef_paymentStatus,
    columnDef_processedDate,
    columnDef_achStatus,
];
